<template>
  <ul class="wrapper">
    <li class='item col-md-12' v-for='(request, idx) in request_group.requests' :key="'request_' + idx">
      <router-link :to="{ name: 'single-demand', params: { id: request.id } }">
        <!-- <span class="date col-md-4"> {{request_group.date}}</span> -->
        <div class="name__wrapper">
          <span class="request-type" v-if="request.included.type">
            <strong>{{ request.included.type.attributes.display_name }}</strong>
          </span>
          <span class="request-customer" v-if="request.included.customer">
            {{ getEnumTranslatedValue('civility', request.included.customer.attributes.civility) }} {{ request.included.customer.attributes.name }}
          </span>
        </div>
        <i class="circle-arrow"></i>
      </router-link>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
  .wrapper {
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    .item {
      display: block;
      padding: 12px;
      text-overflow: ellipsis !important;
      white-space: nowrap;
      border-bottom: 1px solid #ddd;
      &:hover {
        background: #f8f8f8;
      }
      a {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      i {
        margin: 0;
      }
    }
  }
  .name__wrapper {
    display: flex;
    flex-direction: column;
    max-width: 90%;
    text-overflow: ellipsis;
    overflow:hidden;
  }
  .request-type {
    color: #6d6d6d;
    font-size: 14px;
    line-height: 1rem;
    max-width: 100%;
    text-overflow: ellipsis;
    overflow:hidden;
  }
  .request-customer {
    color: #b4b4b4;
    font-size: 12px;
    text-transform: uppercase;
    line-height: 1rem;
    font-weight: 600;
    max-width: 100%;
    text-overflow: ellipsis;
    overflow:hidden;
  }
</style>

<script type="text/babel">
  export default {
    name: "ActivitiesLogItem",
    props:["request_group"]
  }
</script>



// WEBPACK FOOTER //
// client/components/Dashboard/ActivitiesLog/ActivitiesLogItem.vue